<template>
  <section class="twitter">
    <div id="twitter_tl">
      <a
        class="twitter-timeline"
        data-height="300"
        href="https://twitter.com/resident_mynavi?ref_src=twsrc%5Etfw"
        >Tweets by resident_mynavi</a
      >
    </div>
  </section>
</template>

<script lang="ts">
import { onMounted } from 'vue'

export default {
  name: 'WidgetTwitter',

  setup() {
    onMounted(() => {
      if (!document.getElementById('twitter-wjs')) {

        const script = document.createElement('script')
        script.id = 'twitter-wjs'
        script.charset = 'utf-8'
        script.src = 'https://platform.twitter.com/widgets.js'

        const tl = document.querySelector('#twitter_tl')
        if (tl) {
          tl.appendChild(script)
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.twitter {
  padding-top: 40px;
  padding-bottom: 40px;
}

.twitter_heading {
  margin-bottom: 3px;
  line-height: 1;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 500;
}
</style>
